import { Button } from "@/components/ui/button";

export function EmptyState({ icon: Icon, title, desc, actionLabel, onAction, testid, compact = false }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? "px-4 py-10" : "px-6 py-16"}`} data-testid={testid}>
      <div className="relative mb-4">
        <div className="absolute inset-0 rounded-full bg-cyan-400/20 blur-2xl" />
        <div className="relative grid h-16 w-16 place-items-center rounded-2xl border border-cyan-400/30 bg-slate-900/80 text-cyan-300">
          <Icon className="h-7 w-7" />
        </div>
      </div>
      <h3 className="font-display text-lg font-semibold text-white">{title}</h3>
      <p className="mt-1.5 max-w-sm text-sm text-slate-400">{desc}</p>
      {actionLabel && (
        <Button onClick={onAction} data-testid={`${testid}-action`} className="mt-5 bg-cyan-400 font-semibold text-slate-950 hover:bg-cyan-300">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
